import React, { useState } from 'react';
import SectionEdition, { Slot } from 'components/styleguide/section_edition/SectionEdition';
import Sheet from 'components/styleguide/sheet_modal/Sheet';
import InputField from 'components/styleguide/input_field/InputField';
import { useEditableSheet } from 'components/styleguide/sheet_modal/useEditableSheet';
const styles = require('../onboarding-cards.module.scss');

interface CompanyLinksSectionProps {
  website_url: string;
  url: string;
  errors?: Record<string, string>;
}

const CompanyLinksSection: React.FC<CompanyLinksSectionProps> = ({
  website_url,
  url,
  errors,
}) => {
  const [display, setDisplay] = useState({
    website_url: website_url || '',
  });

  const sheet = useEditableSheet({
    url,
    payloadKey: 'company',
    onSuccess: (data) => {
      setDisplay({
        website_url: data.website_url || '',
      });
    },
  });

  const handleEditClick = (action: string) => {
    if (action === 'edit') {
      sheet.open('Edit company links', {
        website_url: display.website_url,
      });
    } else if (action === 'add') {
      sheet.open('Add company link', {
        website_url: '',
      });
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    sheet.handleFormChange(e.target.name, e.target.value);
  };

  const dataFilled = display.website_url.trim();
  const status = dataFilled ? 'complete' : errors?.website_url ? 'mandatory' : 'missing';

  return (
    <>
      <SectionEdition
        title="Company links"
        iconName="link"
        context="company"
        status={status}
        onAdd={() => handleEditClick("add")}
        onEdit={() => handleEditClick("edit")}
      >
        {dataFilled && (
          <Slot>
            <div className={styles.fieldGrid}>
              <div className={styles.field}>
                <p className={styles.label}>Website</p>
                <p className={styles.value}>{display.website_url}</p>
              </div>
          </div>
          </Slot>
        )}
      </SectionEdition>

      {sheet.isOpen && (
        <Sheet
          title={sheet.sheetTitle}
          onClose={sheet.close}
          context="company"
          showCancelButton={false}
          continueButtonText="Save"
          onContinue={sheet.handleSave}
        >
          <div className={styles.form}>
            <InputField
              label="Website"
              placeholder="e.g. https://www.company.com"
              required={true}
              name="website_url"
              value={sheet.formData.website_url || ''}
              onChange={handleInputChange}
              size="M"
              error={sheet.getError('website_url')}
              context="company"
            />
          </div>
        </Sheet>
      )}
    </>
  );
};

export default CompanyLinksSection;
